// utils/turnstile.js — shared Turnstile initializer

// If this page is embedded in a parent frame that is sandboxed
// without `allow-scripts`, Turnstile will create about:blank frames
// and script execution will be blocked. Detect that situation and
// skip initialization to avoid noisy errors in the console.

let turnstileLoading = false;
const widgetIds = {};
const isLocal = location.hostname === 'localhost' || location.hostname === '127.0.0.1';


// At module level
let turnstileReady = false;
const pendingRenders = [];

window.onTurnstileLoad = function () {
  turnstileReady = true;
  pendingRenders.forEach(fn => fn());
  pendingRenders.length = 0;
};


export function initTurnstile({ containerId, tokenFieldId, theme = 'light', onSuccess, onExpire }) {
  if (isLocal) {
    console.info('[Turnstile] Local development - bypassing');

    const field = document.getElementById(tokenFieldId);
    if (field) field.value = 'local-dev-bypass';

    onSuccess?.('local-dev-bypass');
    return;
  }
  try {
    const inIframe = window.top !== window.self;
    const frameEl = window.frameElement;
    if (inIframe && frameEl?.hasAttribute?.('sandbox')) {
      const sandboxAttr = frameEl.getAttribute('sandbox') || '';
      if (!sandboxAttr.includes('allow-scripts')) {
        console.warn('[Turnstile] Sandboxed frame — skipping init');
        return;
      }
    }
  } catch (err) {}

  const container = document.getElementById(containerId);
  if (!container) {
    console.warn('[Turnstile] Container not found:', containerId);
    return;
  }

  const sitekey = container.dataset.sitekey;
  if (!sitekey) {
    console.warn('[Turnstile] Sitekey missing on:', containerId);
    return;
  }

const renderWidget = () => {
  if (!turnstileReady || !window.turnstile) {
    pendingRenders.push(renderWidget);
    return;
  }
  if (widgetIds[containerId] != null) {
    try { window.turnstile.reset(widgetIds[containerId]); } catch (_) {}
    return;
  }
    widgetIds[containerId] = window.turnstile.render(container, {
      sitekey,
      theme: container.dataset.theme || theme,
      callback: token => {
        const field = document.getElementById(tokenFieldId);
        if (field) field.value = token;
        onSuccess?.(token);
      },
      'expired-callback': () => {
        const field = document.getElementById(tokenFieldId);
        if (field) field.value = '';
        onExpire?.();
      }
    });
  };

  if (window.turnstile) {
    renderWidget();
    return;
  }

  if (!turnstileLoading) {
    turnstileLoading = true;
    const scriptId = 'cf-turnstile-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onTurnstileLoad&render=explicit';      script.async = true;
      script.defer = true;
      script.onload = () => {
        turnstileLoading = false;
        renderWidget();
      };
      script.onerror = () => {
        turnstileLoading = false;
        console.warn('[Turnstile] Script load failed');
      };
      document.head.appendChild(script);
    } else {
      // Script tag exists but not loaded yet — wait
      document.getElementById(scriptId).addEventListener('load', () => {
        turnstileLoading = false;
        renderWidget();
      });
    }
  }
}

export function resetTurnstile(containerId) {
  if (widgetIds[containerId] != null && window.turnstile) {
    try {
      window.turnstile.reset(widgetIds[containerId]);
    } catch (err) {}
  }
}
